import { c as _c } from "react/compiler-runtime";
import React, { ReactElement, memo } from 'react';
import classNames from 'clsx';
import styles from './color-checkbox.component.module.scss';
enum AriaChecked {
  TRUE = 'true',
  FALSE = 'false',
  MIXED = 'mixed',
}
export interface Props {
  readonly id: string;
  readonly name: string;
  readonly value: string;
  readonly label: ReactElement | string;
  readonly handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly checked?: boolean;
  readonly disabled?: boolean;
  readonly modified?: boolean;
}
function ColorCheckboxComponent(t0) {
  const $ = _c(35);
  const {
    id,
    name,
    value,
    label,
    handleCheckboxChange,
    checked,
    disabled,
    modified
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = (modified_0, disabled_0) => classNames({
      [styles["checkbox-input"]]: true,
      [styles["checkbox-input--modified"]]: modified_0,
      [styles["checkbox-input--disabled"]]: disabled_0,
      [styles[`checkbox-input--${value}`]]: true
    });
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const checkboxClassFactory = t1;
  let ariaChecked = AriaChecked.FALSE;
  if (modified) {
    ariaChecked = AriaChecked.MIXED;
  } else {
    if (checked) {
      ariaChecked = AriaChecked.TRUE;
    }
  }
  let t2;
  if ($[2] !== disabled) {
    t2 = classNames(styles.checkbox, {
      [styles["checkbox--disabled"]]: disabled
    });
    $[2] = disabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== checked) {
    t3 = classNames(styles["checkbox-input-wrapper"], {
      [styles["checkbox-input-wrapper--checked"]]: checked
    });
    $[4] = checked;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== checkboxClassFactory || $[7] !== disabled || $[8] !== modified) {
    t4 = checkboxClassFactory(modified, disabled);
    $[6] = checkboxClassFactory;
    $[7] = disabled;
    $[8] = modified;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = disabled ? -1 : 0;
  let t6;
  if ($[10] !== ariaChecked || $[11] !== checked || $[12] !== disabled || $[13] !== handleCheckboxChange || $[14] !== id || $[15] !== name || $[16] !== t4 || $[17] !== t5 || $[18] !== value) {
    t6 = <input className={t4} data-testid="checkbox" type="checkbox" id={id} name={name} value={value} checked={checked} disabled={disabled} onChange={handleCheckboxChange} aria-checked={ariaChecked} aria-disabled={disabled} tabIndex={t5} />;
    $[10] = ariaChecked;
    $[11] = checked;
    $[12] = disabled;
    $[13] = handleCheckboxChange;
    $[14] = id;
    $[15] = name;
    $[16] = t4;
    $[17] = t5;
    $[18] = value;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t6) {
    t7 = <div className={t3}>{t6}</div>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== id || $[24] !== label) {
    t8 = <label htmlFor={id} className={styles["checkbox-label"]}>{label}</label>;
    $[23] = id;
    $[24] = label;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <div className={styles["checkbox-input-input-and-label-wrapper"]}>{t7}{t8}</div>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== checked) {
    t10 = checked && <div className={styles["checkbox--checked"]} />;
    $[29] = checked;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t2 || $[33] !== t9) {
    t11 = <div className={t2}>{t9}{t10}</div>;
    $[31] = t10;
    $[32] = t2;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
}
export default memo(ColorCheckboxComponent);